import * as React from 'react';
import styled from 'styled-components';
import { Collapsible } from '../Collapsible';
import { IExpandableSectionProps } from './ExpandableSection.types';
import { SvgImage } from '../SvgImage';
import { getAssetPath } from '../../util/images';
import { NoneButton } from '../AttachmentTag/AttachmentTag';
import { Text } from '../Text/Text';
import { GridRelay, GridFullRow } from '../Grid';

const ExpandableButton = styled(NoneButton)`
  display: flex;
  align-items: center;
`;

const ExpandableSectionIcon = styled(SvgImage)`
  transition: 0.1s;
  transform: rotate(-90deg);

  svg path {
    stroke: ${({ theme }) => theme.colors.font1};
  }

  &.open {
    transform: none;
  }
`;

const ExpandableCustomIcon = styled(SvgImage)`
  svg {
    path[fill] {
      fill: ${({ theme }) => theme.colors.font1};
    }

    path[stroke] {
      stroke: ${({ theme }) => theme.colors.font1};
    }
  }
`;

const ExpandableSection: React.FC<IExpandableSectionProps> = (
  props: IExpandableSectionProps
) => {
  const {
    className,
    title,
    defaultOpen = true,
    titleClassName,
    subtitle,
    subtitleClassName,
    children,
    onClickHandler,
    icon,
    clickHandlerTimeout,
    actionOnClick,
    grid
  } = props;
  const [isOpen, setIsOpen] = React.useState<boolean>(() => defaultOpen);

  return (
    <GridRelay grid={grid} className={className}>
      <Collapsible
        grid={grid}
        open={isOpen}
        header={
          <GridFullRow className="flex-container">
            <ExpandableButton
              type="button"
              onClick={() => {
                setIsOpen(!isOpen);
                if (actionOnClick) {
                  actionOnClick();
                }
                if (onClickHandler && clickHandlerTimeout) {
                  setTimeout(onClickHandler, clickHandlerTimeout);
                } else if (onClickHandler) {
                  onClickHandler();
                }
              }}
            >
              <ExpandableSectionIcon
                inAssetsPath={getAssetPath('icons/expandable-arrow.svg')}
                className={`${isOpen ? 'open' : ''}`}
              />
              <div className="inline-flex-container p-l-10 no-user-select">
                {title ? (
                  <Text color="font1" className={titleClassName ?? 'm-r-3'}>
                    {title}
                  </Text>
                ) : null}
                {subtitle ? (
                  <Text color="font1" className={subtitleClassName}>
                    {subtitle}
                  </Text>
                ) : null}
                {icon && <ExpandableCustomIcon inAssetsPath={icon} />}
              </div>
            </ExpandableButton>
          </GridFullRow>
        }
      >
        <GridRelay grid={grid} className="p-t-20">{children}</GridRelay>
      </Collapsible>
    </GridRelay>
  );
};

export default ExpandableSection;
